import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServiceInfoClientService } from './service/service-info-client.service';
import {
  ClientDebtorRelationViewModel,
  ClientWarranty,
  CompanyLineDetailViewModel,
  CompanyUserAssignment,
  DebtsCompaniesAll,
  Deptors,
  FilterPagination,
  MonthlyActivity,
  Operations,
  RequestDeptors,
  RequestInvoices,
  RequestMinutes,
  ResultsInvoice,
  SummaryCompany,
  WarrantyToNewMinuteVM,
} from './interface/company-client.interface';
import { DateFiltersFilesClients, DateFiltersFilesClientsApproved } from './interface/filters-files-clients.interface';
import { PurchaseOrderComponent } from './modals/purchase-order/purchase-order.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { RegisterMinutesComponent } from './modals/register-minutes/register-minutes.component';
import { TgrFormComponent } from './components/forms/tgr-form/tgr-form.component';
import { CmfFormComponent } from './components/forms/cmf-form/cmf-form.component';
import { ScoringIngeService } from './service/scoring-inge.service';
import { DicomFormularioComponent } from './modals/dicom-formulario/dicom-formulario.component';
import { FogapeInfoClient } from './interface/fogape-client.interface';
import { finalize, Observable } from 'rxjs';
import { RegisterMinuteViewModel, RegisterMinuteWithOperationsVm } from './interface/company-minutes.interface';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { ClientCreditNoteDTO } from './interface/credit-notes.interface';
import { PortfolioService } from '../service/portfolio.service';
import { SelectedCompanyAssignmentToMarkUnmarkFavorite } from '../portfolio/interface/portfolio.interface';
import Swal from 'sweetalert2';
import { ClientDebtorRelationshipModalComponent } from './modals/client-debtor-relationship-modal/client-debtor-relationship-modal.component';
import { FactoringInvoices } from './interface/invoice-operation.interface';
import { ClientCesionarioDTO } from './interface/client-cesionario.interface';
import { ModalLoadingFileClientsComponent } from '../modals/modal-loading-file-clients/modal-loading-file-clients.component';
import { ModalUpdateInvocesComponent } from '../modals/modal-update-invoces/modal-update-invoces.component';
import { AwaitingPaymentWarrantyColumnSettings, PendingWarrantyColumnSettings, WarrantyColumnSettings } from './settings/client-table-settings';
import { CompaniesFactoringService } from '../factoring/services/companies-factoring.service';
import { RegisterMinuteWithOpsComponent } from './modals/register-minute-with-ops/register-minute-with-ops.component';
import { ChangeSIIPassComponent } from '../modals/change-siipass/change-siipass.component';
import { UpdateWarrantyAmountModalComponent } from '../warranties/modals/update-warranty-amount-modal/update-warranty-amount-modal.component';
import { WarratyContractAmountVM } from './interface/warranty.interface';

@Component({
  selector: 'app-files-clients',
  templateUrl: './files-clients.component.html',
  styleUrls: ['./files-clients.component.scss'],
})
export class FilesClientsComponent implements OnInit {
  public summaries?: SummaryCompany = this.summaries;
  public monthlySummaries?: MonthlyActivity[] = this.monthlySummaries;
  public fogapeClient?: FogapeInfoClient;
  public deptors$: Observable<Deptors[]>;
  public companyLineSummary: CompanyLineDetailViewModel | null;
  public resultsInvoice$: Observable<ResultsInvoice>;
  public resultSellInvoiceFactoring: FactoringInvoices[];
  public requestInvoice: RequestInvoices;
  public minutes: Array<RequestMinutes>;
  public debtsCompanies: DebtsCompaniesAll;
  public operations: Operations[];
  public spinnerShow: boolean = false;
  public rutUrl: number;
  public deuda: number = 0;
  public historialDicom: boolean = false;
  public powerBiUrl: string;
  public fileClientFilter: DateFiltersFilesClients;
  public fileClientFilterApproved: DateFiltersFilesClientsApproved;
  public myCompanyAssignment$: Observable<CompanyUserAssignment | null>;
  public companyInfoPortafolio$: Observable<CompanyUserAssignment | null>;
  public cargandoDatos: boolean = false;
  public updateOwner: boolean;
  public loadingSpinner: boolean = false;
  selectedIndex = 0;
  private startX = 0;
  private currentX = 0;
  public selectedVal: string;
  public currentSGRScoringState: number | null = null;

  /**
   * Paginacion de tabla de notas de credito
   */
  public paginationCreditNotes: FilterPagination = {
    page: 1,
    pageSize: 10,
  };
  public creditNotesResponse$: Observable<PageResult<ClientCreditNoteDTO>>;
  public operations$: Observable<Operations[]>;
  public operationsApproved$: Observable<Operations[]>;
  public operationsApproved: Operations[];
  public buyInvoices$: Observable<PageResult<ResultsInvoice>>;
  public minutes$: Observable<RequestMinutes[]>;
  public cesionarios$: Observable<PageResult<ClientCesionarioDTO>>;
  public buyInvocesFact$: Observable<PageResult<FactoringInvoices>>;
  public warranties$: Observable<ClientWarranty[]>;
  public pendingApproveWarranties$: Observable<ClientWarranty[]>;
  public awaitingPaymentWarranties$: Observable<ClientWarranty[]>;

  public paginationInvoice: FilterPagination = {
    page: 1,
    pageSize: 5,
  };

  /**
   * Paginacion de tabla de facturas compradas
   */
  public paginationBuyInvoice: FilterPagination = {
    page: 1,
    pageSize: 5,
  };

  public paginationCesionario: FilterPagination = {
    page: 1,
    pageSize: 5,
  };

  public paginationFactoring: FilterPagination = {
    page: 1,
    pageSize: 5,
  };

  public warrantyTableColsConfig = WarrantyColumnSettings;
  public pendingWarrantyTableColsConfig = PendingWarrantyColumnSettings;
  public tableSettings = {
    awatingPaymentColumn: AwaitingPaymentWarrantyColumnSettings,
  };
  public sellInvoiceSort: string;
  public fogapeSpinnerShow = false;
  public tgrSpinnerShow = false;
  public dicomSpinnerShow = false;
  public cmfSpinnerShow = false;

  public warrantyRowEvents = [
    {
      eventHandler: (row: any) => {
        this.openUpdateWarrantyAmount(row);
      },
      title: 'Modificar tamaño contrato',
    },
  ];

  constructor(
    private serviceDebtorList: CompaniesFactoringService,
    private equifaxService: ScoringIngeService,
    private cdref: ChangeDetectorRef,
    private serviceInfo: ServiceInfoClientService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private portfolioService: PortfolioService
  ) {
    this.myCompanyAssignment$ = new Observable<CompanyUserAssignment | null>();
    this.companyInfoPortafolio$ =
      new Observable<CompanyUserAssignment | null>();
    this.companyLineSummary = null;
    this.creditNotesResponse$ = new Observable<
      PageResult<ClientCreditNoteDTO>
    >();
    this.operations$ = new Observable<Operations[]>();
    this.operationsApproved$ = new Observable<Operations[]>();
    this.buyInvoices$ = new Observable<PageResult<ResultsInvoice>>();
    this.minutes$ = new Observable<RequestMinutes[]>();
    this.cesionarios$ = new Observable<PageResult<ClientCesionarioDTO>>();
    this.warranties$ = new Observable<ClientWarranty[]>();
    this.awaitingPaymentWarranties$ = new Observable<ClientWarranty[]>();
    const currentDate = new Date();
    const currentDateStr: string = currentDate.toISOString();
    this.fileClientFilter = {
      end: currentDateStr,
      start: new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - 12,
        currentDate.getDate()
      ).toISOString(),
      search: '',
      
    };

    this.fileClientFilterApproved = {
      end: currentDateStr,
      start: new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - 12,
        currentDate.getDate()
      ).toISOString(),
      search: '',
      idState: -3,
    };
  }

  public options = {
    chart: {
      type: 'line',
    },
    series: [
      {
        name: 'sales',
        data: [30, 40, 35, 50, 49, 60, 70, 91, 125],
      },
    ],
    xaxis: {
      categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999],
    },
  };

  ngOnInit() {
    this.openModalLoading();
    this.selectedVal = 'dashboard';
    this.route.queryParams.subscribe((params: any) => {
      const { client } = params;
      this.rutUrl = parseInt(client);
      this.getSummaries(this.rutUrl);
      this.getMonthlySummaries(this.rutUrl);
      this.getDeptors(this.rutUrl);
      this.getInvoices(this.rutUrl);
      this.getDatosInvoicesFactoring(this.rutUrl);
      this.getInvocesFactoring(this.rutUrl);
      this.getOperations(this.rutUrl);
      this.getFogapeInfo(this.rutUrl);
      this.getCompanyCreditNotes(this.rutUrl);
      this.getCompanyBuyInvoices(this.rutUrl);
      this.receiveDebtsCompanie(this.rutUrl);
      this.getCompanyCesionarios(this.rutUrl);
      this.getClientWarranties(this.rutUrl);
      this.getOperationsAprovved(this.rutUrl);
      this.getClientPendingApproveWarranties(
        this.rutUrl,
        this.fileClientFilter.search
      );
      this.getClientAwaitingPaymentWarranties(this.rutUrl);
      setTimeout(() => {
        this.getDeudaEquifaxBD(this.rutUrl);
        this.getMinutes(this.rutUrl);
        this.getMyAssignmentCompany(this.rutUrl);
        this.getInfoPortafolio(this.rutUrl);
      }, 1250);
    });
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  ngOnDestroy(): void {
    this.closeModalLoading();
  }

  //Obtencion de Informacion para las tablas///
  getDeptors(rut: number) {
    const data: RequestDeptors = {
      id: rut,
      start: this.fileClientFilter.start,
      end: this.fileClientFilter.end,
      search: this.fileClientFilter.search,
      top: null,
    };
    this.deptors$ = this.serviceInfo.debtorsCompany(data);
  }

  /**
   * Metodo para consultar las facturas de un cliente
   * @param rut
   */
  getInvoices(rut: number) {
    this.resultsInvoice$ = this.serviceInfo.invoices(
      rut,
      this.fileClientFilter,
      this.paginationInvoice
    );
    // this.serviceInfo
    //   .invoices(rut, this.fileClientFilter, this.paginationInvoice)
    //   .subscribe((e) => {
    //     this.resultsInvoice = e;
    //   });
  }

  /**
   * Metodo para consultar las operaciones asociadas al cliente
   * @param rut Rut sin DV del cliente
   */
  getOperations(rut: number) {
    this.operations$ = this.serviceInfo.getOperations(
      rut,
      this.fileClientFilter
    );
    this.operations$.subscribe((e) => console.log(e));
  }

  getOperationsAprovved(rut: number) {
    this.operationsApproved$ = this.serviceInfo.getOperationsApproved(
      rut,
      this.fileClientFilterApproved
    );
    this.operationsApproved$.subscribe((e) => this.operationsApproved = e);
  }

  //cambia la tabla cuando se crea una nueva///
  receiveBoolean(boolea: any) {
    if (boolea) this.getOperations(this.rutUrl);
  }

  receiveSGRScoringState(status: number) {
    this.currentSGRScoringState = status;
  }

  /**
   * Metodo para recibir un cambio en la paginacion de la tabla de facturas y
   * realizar la consulta a las facturas de acuerdo a estos cambios
   * @param pages Datos con la pagina seleccionada (page) y cantidad de registros por pagina (pageSize)
   */
  filterPageSize(pages: any) {
    const { pageSize, page } = pages;

    this.paginationInvoice = {
      ...this.paginationInvoice,
      page: page,
      pageSize: pageSize,
    };

    this.getInvoices(this.rutUrl);
  }

  /**
   * Recibir cambios en el ordenamiento para las facturas de venta del cliente
   * @param sortOrder
   */
  receiveChangeSellInvoicesOrder(sortOrder: string) {
    this.paginationInvoice = {
      ...this.paginationInvoice,
      sortOrder: sortOrder,
    };
    this.sellInvoiceSort = sortOrder;
    this.getInvoices(this.rutUrl);
  }

  receiveChangeCesionarioOrder(sortOrder: string) {
    this.paginationCesionario = {
      ...this.paginationCesionario,
      sortOrder: sortOrder,
    };
    this.getCompanyCesionarios(this.rutUrl);
  }

  receiveChangeInvoceFactoringOrder(sortOrder: string) {
    this.paginationFactoring = {
      ...this.paginationFactoring,
      sortOrder: sortOrder,
    };
    this.getCompanyCesionarios(this.rutUrl);
  }

  receiveChangeFactoringPagination(pagination: FilterPagination) {
    this.paginationFactoring = {
      ...this.paginationFactoring,
      page: pagination.page,
      pageSize: pagination.pageSize,
    };
    this.getCompanyCesionarios(this.rutUrl);
  }

  receiveChangeCesionarioPagination(pagination: FilterPagination) {
    this.paginationCesionario = {
      ...this.paginationCesionario,
      page: pagination.page,
      pageSize: pagination.pageSize,
    };
    this.getCompanyCesionarios(this.rutUrl);
  }

  /**
   * Recibir cambios en el ordenamiento para las facturas de compra del cliente
   * @param sortOrder
   */
  receiveChangeBuyInvoicesOrder(sortOrder: string) {
    this.paginationBuyInvoice = {
      ...this.paginationBuyInvoice,
      sortOrder: sortOrder,
    };
    this.getCompanyBuyInvoices(this.rutUrl);
  }

  /**
   * Recibir cambios en el ordenamiento que debe realizar la API con las notas de credito
   * @param sortOrder string con ordenamiento a enviar a API
   */
  receiveChangeCreditNotesOrder(sortOrder: string) {
    this.paginationCreditNotes = {
      ...this.paginationCreditNotes,
      sortOrder: sortOrder,
    };
    this.getCompanyCreditNotes(this.rutUrl);
  }

  /**
   * Metodo para obtener datos de resumen de un cliente
   * @param rut Rut de cliente
   */
  getSummaries(rut: number) {
    this.spinnerShow = true;
    this.serviceInfo.summaryCompany(rut, this.fileClientFilter).subscribe({
      next: (e) => {
        this.spinnerShow = true;
        this.summaries = e;
        this.discardDebtorIcon(e);
        this.setCompanyLineSummary(e);
        this.cargandoDatos = true;
        this.closeModalLoading();
      },
      error: () => {},
      complete: () => {
        this.spinnerShow;
      },
    });
  }

  getMonthlySummaries(rut: number) {
    this.serviceInfo
      .monthlySummaryCompany(rut, this.fileClientFilter)
      .subscribe({
        next: (e) => {
          this.monthlySummaries = e;
        },
        error: () => {},
        complete: () => {
          this.spinnerShow;
        },
      });
  }

  receiveBooelan(bool: boolean) {
    if (bool) this.getSummaries(this.rutUrl);
  }

  discardDebtorIcon(e: SummaryCompany) {
    const debtor = e.isDebtor;
    const debtorBlack = e.debtorBlackList;
    const debtorFavorite = e.debtorFavorite;
    if (debtorBlack == true) {
      this.summaries.isDebtor = false;
    }
    if (debtorFavorite == true) {
      this.summaries.isDebtor = false;
    }
  }
  getDeudaDicomEquifax(rut: String) {
    this.dicomSpinnerShow = true;
    var rutformat = rut.split('.').join('');
    this.equifaxService
      .getDeudaDicom(rutformat)
      .pipe(finalize(() => (this.dicomSpinnerShow = false)))
      .subscribe((result) => {
        if (Number(result.deuda) <= 50000) {
          this.summaries.hasDicom = true;
        } else {
          this.summaries.hasDicom = false;
        }
      }),
      (error) => {
        console.log('Error Get DicomPerona:' + error);
      };
  }

  getDeudaEquifaxBD(rut: number) {
    this.equifaxService.getEquifaxReportBD(rut).subscribe((result) => {
      this.deuda = result?.deudaDicom;
      if (result?.deudaDicom == null) {
        this.historialDicom = false;
      } else if (Number(result?.deudaDicom) <= 50000) {
        this.summaries.hasDicom = true;
        this.historialDicom = true;
      } else {
        this.summaries.hasDicom = false;
        this.historialDicom = true;
      }
    });
  }

  private setCompanyLineSummary(companySummary: SummaryCompany) {
    this.companyLineSummary = {
      approvedLine: companySummary.approvedLine,
      amountMora: companySummary.amountEnMora,
      amountVencido: companySummary.amountVencido,
      isLineActive: companySummary.lineActive,
    };
  }

  /**
   * Metodo para obtener las minutas registradas
   * @param rut
   */
  getMinutes(rut: number) {
    this.minutes$ = this.serviceInfo.minutes(rut);
    // this.serviceInfo.minutes(rut).subscribe((e) => {
    //   this.minutes = e;
    // });
  }

  setPowerBiFrame(event: any) {
    if (event?.tab?.textLabel === 'PowerBi') {
      const rutWithoutDots = this.summaries?.rut.replace(/\./g, '') || '';
      this.powerBiUrl = `https://app.powerbi.com/view?r=eyJrIjoiYjY5OGNhOWItNTNiMy00NWFiLWJjNDItZTk2YTU2MjM5ZTE1IiwidCI6ImI5YTAwMDlmLWNhNWMtNDZiZC1hYjQ3LTEwZDg3NDRiYmQ3NiJ9&filterPaneEnabled=false&pageName=Cliente&filter=companies/RutConFormato eq '${rutWithoutDots}'`;
      const powerBiFrameHtml = `<iframe id="powerBiFrame" title="DatosFactoring_embedded" width="1140" height="541.25" frameborder="0" allowFullScreen="true" src="${this.powerBiUrl}"></iframe>`;
      const PowerBiDiv = document.getElementById('PowerBiFrameDiv');
      if (PowerBiDiv) {
        PowerBiDiv.innerHTML = powerBiFrameHtml;
      }
    }
  }

  //Filtro Top 10 Deudor
  filterTop(event: number) {
    const data: RequestDeptors = {
      id: this.rutUrl,
      top: event,
    };
    this.deptors$ = this.serviceInfo.debtorsFiltersCompany(data);
  }

  public openViewInvoiceBuyOrder(invoiceId: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = '40%';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.minWidth = '300px';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.data = invoiceId;
    const dialogRef = this.dialog.open(PurchaseOrderComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((res: boolean) => {
      if (res) this.getInvoices(this.rutUrl);
    });
  }

  public openViewRegisterMinutes() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = '70vw';
    dialogConfig.height = 'auto';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '90vh';
    const viewModel: RegisterMinuteViewModel = {
      companyId: this.rutUrl,
    };
    dialogConfig.data = viewModel;

    const dialogRef = this.dialog.open(RegisterMinutesComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((res: boolean) => {
      if (res) this.getMinutes(this.rutUrl);
    });
  }

  public formTGR() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = 'container_form_debts';
    dialogConfig.data = this.rutUrl;

    const dialogRef = this.dialog.open(TgrFormComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((res: boolean) => {
      if (res) {
        this.receiveDebtsCompanie(this.rutUrl);
      } else {
        this.receiveDebtsCompanie(this.rutUrl);
      }
    });
  }

  public formCMF() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = 'sbif_container';
    dialogConfig.data = {
      rut: this.rutUrl,
      isPartner: false,
      name: this.summaries?.name,
    };
    const dialogRef = this.dialog.open(CmfFormComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((res: boolean) => {
      if (res) {
        this.receiveDebtsCompanie(this.rutUrl);
      } else {
        this.receiveDebtsCompanie(this.rutUrl);
      }
    });
  }

  public formDicom() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '50vw';
    dialogConfig.height = '450px';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.data = this.summaries!.rut;

    const dialogRef = this.dialog.open(DicomFormularioComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((res: boolean) => {
      this.receiveDebtsCompanie(this.rutUrl);
      if (res) {
        console.log(res);
        this.updateOwner = res;
        this.getDeudaEquifaxBD(this.rutUrl);
        this.getOwners(this.rutUrl);
        this.getSummaries(this.rutUrl);
        this;
      } else {
        this.getDeudaEquifaxBD(this.rutUrl);
      }
    });
  }

  public getOwners(rut: number) {
    this.serviceInfo.getCompanyRelations(rut).subscribe((e) => {
      console.log(e);
    });
  }

  public openModalLoading() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = 'auto';
    dialogConfig.height = 'auto';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = 'transparent-dialog';
    dialogConfig.backdropClass = 'transparent-backdrop';
    this.dialog.open(ModalLoadingFileClientsComponent, dialogConfig);
  }

  public openModalUpdateInvoces() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = 'auto';
    dialogConfig.height = 'auto';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.autoFocus = true;
    dialogConfig.data = this.rutUrl;
    this.dialog.open(ModalUpdateInvocesComponent, dialogConfig);
  }

  public closeModalLoading() {
    this.dialog.closeAll();
  }

  public refreshFogape() {
    this.getFogapeInfo(this.rutUrl);
  }

  public getFogapeInfo(companyId: number) {
    this.fogapeSpinnerShow = true;
    this.serviceInfo
      .getFogapeInfo(companyId)
      .pipe(
        finalize(() => {
          this.fogapeSpinnerShow = false;
        })
      )
      .subscribe({
        next: (response) => {
          this.fogapeClient = response;
        },
        error: (error) => {
          this.fogapeClient = null;
        },
      });
  }

  /**
   * Metodo para obtener las notas de creditos del cliente
   * @param companyId
   */
  getCompanyCreditNotes(companyId: number) {
    const filter: RequestDeptors = {
      id: this.rutUrl,
      start: this.fileClientFilter.start,
      end: this.fileClientFilter.end,
      search: this.fileClientFilter.search,
    };
    this.creditNotesResponse$ = this.serviceInfo.getCompanyCreditNotes(
      companyId,
      this.fileClientFilter,
      this.paginationCreditNotes
    );
  }

  getCompanyBuyInvoices(companyId: number) {
    this.buyInvoices$ = this.serviceInfo.getCompanyBuyInvoices(
      companyId,
      this.fileClientFilter,
      this.paginationBuyInvoice
    );
  }

  getDatosInvoicesFactoring(companyId: number) {
    this.serviceInfo.getSellFactoringInvoice(companyId).subscribe((result) => {
      this.resultSellInvoiceFactoring = result;
    });
    (error) => {
      console.log('Error Get DicomPerona:' + error);
    };
  }

  getCompanyCesionarios(companyId: number) {
    this.cesionarios$ = this.serviceInfo.getCompanyCesionarios(
      companyId,
      this.fileClientFilter,
      this.paginationCesionario
    );
  }

  getInvocesFactoring(companyId: number) {
    this.buyInvocesFact$ = this.serviceInfo.getCompanyBuyInvoicesFactoring(
      companyId,
      this.fileClientFilter,
      this.paginationFactoring
    );
  }

  getClientWarranties(companyId: number) {
    this.warranties$ = this.serviceInfo.getCompanyWarranties(
      companyId,
      this.fileClientFilter.search
    );
  }

  receiveBooleanWarrantiyes(bool: boolean) {
    if (bool)
      this.getClientPendingApproveWarranties(
        this.rutUrl,
        this.fileClientFilter.search
      );
  }
  getClientPendingApproveWarranties(companyId: number, search: string) {
    this.pendingApproveWarranties$ =
      this.serviceInfo.getCompanyPendingApproveWarranties(companyId, search);
  }

  getClientAwaitingPaymentWarranties(companyId: number) {
    this.awaitingPaymentWarranties$ =
      this.serviceInfo.getAwaitingPaymentWarranties(companyId);
  }

  receiveChangeBuyInvoiceFactoringPagination(pagination: FilterPagination) {
    this.paginationFactoring = {
      ...this.paginationFactoring,
      page: pagination.page,
      pageSize: pagination.pageSize,
    };
    this.getInvocesFactoring(this.rutUrl);
  }

  receiveChangeCreditNotePagination(pagination: FilterPagination) {
    this.paginationCreditNotes = {
      ...this.paginationCreditNotes,
      pageSize: pagination.pageSize,
      page: pagination.page,
    };
    this.getCompanyCreditNotes(this.rutUrl);
  }

  receiveChangeBuyInvoicePagination(pagination: FilterPagination) {
    this.paginationBuyInvoice = {
      ...this.paginationBuyInvoice,
      page: pagination.page,
      pageSize: pagination.pageSize,
    };
    this.getCompanyBuyInvoices(this.rutUrl);
  }

  /**
   * Metodo que recibe los nuevos valores de los filtros
   * @param event Nuevo parametros actualizados de los filtros
   */
  receiveUpdatedFilters(event: DateFiltersFilesClients) {
    this.fileClientFilter = {
      ...this.fileClientFilter,
      start: event.start || this.fileClientFilter.start,
      end: event.end || this.fileClientFilter.end,
      search: event.search,
      preference: event.preference,
    };

    this.getCompanyCreditNotes(this.rutUrl);
    this.getInvoices(this.rutUrl);
    this.getMinutes(this.rutUrl);
    this.getDeptors(this.rutUrl);
    this.getOperations(this.rutUrl);
    this.getCompanyBuyInvoices(this.rutUrl);
    this.getSummaries(this.rutUrl);
    this.getMonthlySummaries(this.rutUrl);
    this.getCompanyCesionarios(this.rutUrl);
    this.getInvocesFactoring(this.rutUrl);
    this.getClientWarranties(this.rutUrl);
    this.getClientPendingApproveWarranties(
      this.rutUrl,
      this.fileClientFilter.search
    );
  }

  receiveDebtsCompanie(companyId: number) {
    this.serviceInfo.getDebtCompanies(companyId).subscribe((e) => {
      this.debtsCompanies = e;
    });
  }

  getMyAssignmentCompany(rut: number) {
    this.myCompanyAssignment$ = this.serviceInfo.getMyAssignmentInCompany(rut);
  }

  getInfoPortafolio(rut: number) {
    this.companyInfoPortafolio$ =
      this.portfolioService.getInfoPortafolioCompany(rut);
  }

  markOrUnmark(assignment: CompanyUserAssignment) {
    this.loadingSpinner = true;
    const request: SelectedCompanyAssignmentToMarkUnmarkFavorite = {
      companyId: assignment.companyId,
      portfolioId: assignment.portfolioId,
    };

    const requestObs$ = assignment.isFavorite
      ? this.portfolioService.unmarkAssignCompanyAsFavorite(request)
      : this.portfolioService.markAssignCompanyAsFavorite(request);
    requestObs$.subscribe({
      next: (res) => {
        this.getMyAssignmentCompany(this.rutUrl);
        this.loadingSpinner = false;
      },
    });
  }

  assignClientToMyPortfolio() {
    this.portfolioService.assignCompanyToMyPortfolio(this.rutUrl).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          text: res.resultMessage,
        });
        this.getMyAssignmentCompany(this.rutUrl);
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          text: err.error.resultMessage,
        });
      },
    });
  }

  receiveDebtorCompanyIdToViewRelationship(debtorCompanyId: number) {
    const clientToDebtorVm: ClientDebtorRelationViewModel = {
      clientCompanyId: this.rutUrl,
      debtorCompanyId: debtorCompanyId,
      datePreference: this.fileClientFilter?.preference ?? 12,
      startDate: this.fileClientFilter.start,
      endDate: this.fileClientFilter.end,
    };
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '80vw';
    dialogConfig.height = '85vh';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '85vh';
    dialogConfig.data = clientToDebtorVm;

    this.dialog.open(ClientDebtorRelationshipModalComponent, dialogConfig);
  }

  touchStart(event: TouchEvent): void {
    this.startX = event.touches[0].clientX;
  }

  touchMove(event: TouchEvent): void {
    this.currentX = event.touches[0].clientX;
  }

  touchEnd(): void {
    const deltaX = this.currentX - this.startX;
    if (deltaX > 50 && this.selectedIndex > 0) {
      this.selectedIndex--;
    } else if (deltaX < -50 && this.selectedIndex < 4) {
      this.selectedIndex++;
    }
  }

  addDebtorFavorite() {
    this.serviceDebtorList.updateDebtorFavorite(this.rutUrl).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          text: 'Compañia Agregada a Deudres Favoritos',
        });
        this.getSummaries(this.rutUrl);
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          text: err.error.resultMessage,
        });
      },
    });
  }

  addDebtorBlackList() {
    this.serviceDebtorList.updateDebtorBalackList(this.rutUrl).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          text: 'Compañia Agregada a Lista Negra',
        });
        this.getSummaries(this.rutUrl);
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          text: err.error.resultMessage,
        });
      },
    });
  }

  createMinuteWithWarranties(warranties: WarrantyToNewMinuteVM[]) {
    const request: RegisterMinuteWithOperationsVm = {
      clientCompanyId: this.rutUrl,
      operations: [],
      warranties: warranties,
    };
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '50vw';
    dialogConfig.height = '650px';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.data = request;

    const dialogRef = this.dialog.open(
      RegisterMinuteWithOpsComponent,
      dialogConfig
    );
  }

  public updateSIIPass(data: string) {
    const request = {
      isSiiConnected: this.debtsCompanies.isSiiConnected,
      rut: data,
    };
    this.debtsCompanies;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.panelClass = 'modalChangePassSii';
    dialogConfig.data = request;
    const dialogRef = this.dialog.open(ChangeSIIPassComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((res: boolean) => {
      console.log(res);
      if (res) this.receiveDebtsCompanie(this.rutUrl);
    });
  }

  openUpdateWarrantyAmount(warranty: any) {
    const vm: WarratyContractAmountVM = {
      warrantyId: warranty.warrantyId,
      contractAmount: warranty.contractAmount,
    };
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '30vw';
    dialogConfig.height = '24vh';
    dialogConfig.maxWidth = '95vw';
    dialogConfig.maxHeight = '50vh';
    dialogConfig.data = vm;
    const dialogRef = this.dialog.open(
      UpdateWarrantyAmountModalComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe({
      next: (res: boolean) => {
        if (res === true) {
          this.getClientPendingApproveWarranties(
            this.rutUrl,
            this.fileClientFilter.search
          );
          this.getClientAwaitingPaymentWarranties(this.rutUrl);
          this.getClientWarranties(this.rutUrl);
        }
      },
    });
  }

  onValChange(value) {
    this.selectedVal = value;
  }

  stopPropagation(event: Event): void {
    event.stopPropagation();
  }

}
